import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { formatCurrency } from '../../utils/formatters';
import type { ChartDataPoint } from '../../types';

interface RevenueChartProps {
  data: ChartDataPoint[];
}

const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length) {
    return (
      <div style={{ background: '#fff', padding: '8px', border: '1px solid #ccc' }}>
        <p>{payload[0].payload.date}</p>
        <p style={{ color: '#52c41a' }}>
          <strong>{formatCurrency(payload[0].value)}</strong>
        </p>
      </div>
    );
  }
  return null;
};

export const RevenueChart: React.FC<RevenueChartProps> = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip content={<CustomTooltip />} />
        <Legend />
        <Bar dataKey="revenue" fill="#52c41a" name="Виручка" />
      </BarChart>
    </ResponsiveContainer>
  );
};
